import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ChristmasTheme from './components/ChristmasTheme/ChristmasTheme';
import HalloweenTheme from './components/HalloweenTheme/HalloweenTheme';
import ClosureBanner from './components/ClosureBanner';
import Header from './layouts/Header';
import Footer from './layouts/Footer';
import HeroSection from './pages/HeroSection';
import AboutPage from './pages/AboutPage';
import MenuPage from './pages/MenuPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import SuccessPage from './pages/SuccessPage';
import AdminPage from './pages/AdminPage';
import './styles/App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ChristmasTheme />
        <HalloweenTheme />
        <ClosureBanner />
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HeroSection />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/product/:productId" element={<ProductDetailPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
